/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SchoolReason {
  type?: 'school';
  school_name: string;
  from_year: number;
  to_year: number;
  same_major: boolean;
}
